module.exports = __webpack_public_path__ + "static/media/sbay-app-logo.db924224.png";